module.exports = __webpack_public_path__ + "img/services.d584bb01.svg";